import type { IconSvgObject } from './types';

const Calculator01Icon: IconSvgObject = [
  ["path", { d: "M3.5 9.5H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 6L17.5 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.5 19.5V4.5C20.5 3.39543 19.6046 2.5 18.5 2.5H5.5C4.39543 2.5 3.5 3.39543 3.5 4.5V19.5C3.5 20.6046 4.39543 21.5 5.5 21.5H18.5C19.6046 21.5 20.5 20.6046 20.5 19.5Z", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 13.5H8M16 13.5H17M12.5 13.5H11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M7 17.5H8M16 17.5H17M12.5 17.5H11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Calculator01Icon;
